module.exports = ".navbar {\n  background: #1E88E5;\n  margin: 0;\n  padding: 0;\n  border: none; }\n\n.top-bar {\n  background-color: #1E88E5;\n  height: 55px;\n  border: none; }\n\n.logo {\n  max-height: 40px;\n  margin-left: 15px;\n  margin-top: 5px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/nav-bar/nav-bar.component.scss
// module id = ./src/app/shared/components/nav-bar/nav-bar.component.scss
// module chunks = main